import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";
import type { IPhoneNumber } from "@/interfaces";
import { EmptyPhoneNumber } from "@constants";

export interface IForgetPasswordFormSchema {
  phoneNumber: IPhoneNumber;
}

export const forgetPasswordFormInitialValues: IForgetPasswordFormSchema = {
  phoneNumber: EmptyPhoneNumber,
};

export const forgetPasswordFormValidationSchema = z.object<
  IShapeOfField<IForgetPasswordFormSchema>
>({
  phoneNumber: z.phone(),
});
